import { Component, OnInit, ViewChild, Input, Output, EventEmitter, Inject, LOCALE_ID } from '@angular/core';
import { FormControl } from '@angular/forms';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { createOfflineCompileUrlResolver } from '@angular/compiler';

@Component({
  selector: 'app-weekday-select-input',
  templateUrl: './weekday-select-input.component.html',
  styleUrls: ['./weekday-select-input.component.scss']
})
export class WeekdaySelectInputComponent implements OnInit {

  @Input() control: FormControl;
  @Output() inputChange = new EventEmitter<void>();
  @ViewChild('wrapper', { static: true }) wrapper;

  private value: string;
  private valid: boolean;

  // In that order: Sunday, Monday, Tuesday, Wednesday, Thursday, Friday, Saturday
  public weekdaySelected: boolean[] = [false, false, false, false, false, false, false];

  constructor(
    @Inject(LOCALE_ID) private locale: string
  ) { }

  ngOnInit() {
    const isDefault = !(this.control && this.control.value);
    const value = isDefault ? 'Monday, Tuesday, Wednesday, Thursday, Friday' : this.control.value.toString();
    this.value = value; // Will be updated by updateControl if empty

    this.initWeekdaySelectedFromString(value);
    this.updateControl();
  }

  isEnglishLocale() {
    return !(typeof this.locale === "string" && this.locale.toLowerCase().substring(0, 2) === "pt");
  }

  getWeekdayByIndex(index: number | string) {
    if (typeof index === 'string') {
      index = parseInt(index, 10);
    }
    return [
      'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'
    ][index] || (index === undefined || index === null ? '?' : index.toString());
  }

  // Use english or portuguese weekday strings depending on language
  getLocaleWeekdayByIndex(index: number | string) {
    if (this.isEnglishLocale()) {
      return this.getWeekdayByIndex(index);
    }
    if (typeof index === 'string') {
      index = parseInt(index, 10);
    }
    return [
      'Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'
    ][index] || (index === undefined || index === null ? '?' : index.toString());
  }

  onInputChange() {
    this.updateControl();
  }

  updateControl() {
    let hasChanged = false;
    const selections = this.weekdaySelected.map((v, i) => {console.log(v,i); return v ? this.getWeekdayByIndex(i) : ''}).filter(v => v);
    const value = JSON.stringify(selections);
    console.log(selections,value)
    if (value !== this.value) {
      this.value = value;
      if (this.control) {
        this.control.setValue(value);
        this.control.markAsDirty();
        this.control.markAsTouched();
      }
      hasChanged = true;
    }
    const isValid = selections.length !== 0;
    if (isValid !== this.valid) {
      this.valid = isValid;
      if (this.control) {
        this.control.setErrors(isValid ? null : {required: true});
      }
      hasChanged = true;
    }
    if (hasChanged) {
      this.inputChange.emit();
    }
  }

  onLabelClick(event) {
    let label;
    if (!(event.target instanceof HTMLLabelElement)) {
      label = event.target.querySelector('label');
    } else {
      label = event.target;
    }
    const group = label.parentNode;
    const index = group.getAttribute('data-id');
    if (index === undefined || index === null || index === '') {
      console.warn('Group was missing data index:', group);
      return;
    }
    this.weekdaySelected[index] = !this.weekdaySelected[index];
    this.onInputChange();
  }

  /**
   * Decode a string of numbers into the internal representation of states on the component
   *
   * @param stringValue The raw string of weekdays in the format 0,1,2,3,4,5,6 where missing numbers are indication of unselection
   */
  initWeekdaySelectedFromString(stringValue: string) {
    var values: number[];
    try{
      values = JSON.parse(stringValue);
    }
      catch(e){
        values = stringValue.split(',').map(str => parseInt(str, 10));
      }
    for (let i = 0; i < 7; i++) {
      this.weekdaySelected[i] = values.some(value => value === i);
    }
  }

}
